import React, { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

function outcomeBadge(entry) {
  if (entry.status === 'winner') return { label: 'Won', cls: 'badge-blue' }
  if (entry.status === 'eliminated') return { label: 'Eliminated', cls: 'badge-red' }
  if (entry.status === 'removed') return { label: 'Removed', cls: 'badge-gray' }
  return { label: 'Alive', cls: 'badge-green' }
}

// Compact history list for the "Past rounds" tab: every complete/rolled_over
// round the player has an entry in, one row each, linking through to that
// round's detail (LMSEventPage's ?round= view, which reuses RoundHistoryPanel
// for the standings/picks/board). Winner names aren't on lms_rounds directly
// readable by name -- get_lms_round_winner_name() resolves winner_entry_id to
// a display name (least-privilege RPC, only returns anything once the round
// is actually 'complete'), so fetch it per round here rather than in the
// parent's main load.
export default function PastRoundsTab({ eventId, pastRounds }) {
  const [winners, setWinners] = useState(new Map())

  useEffect(() => {
    const completeRounds = pastRounds.filter(({ round }) => round.status === 'complete')
    if (completeRounds.length === 0) return
    let cancelled = false
    Promise.all(
      completeRounds.map(({ round }) =>
        supabase.rpc('get_lms_round_winner_name', { p_round_id: round.id }).then(({ data }) => [round.id, data])
      )
    ).then(results => {
      if (cancelled) return
      setWinners(new Map(results.filter(([, name]) => !!name)))
    })
    return () => { cancelled = true }
  }, [pastRounds])

  if (pastRounds.length === 0) {
    return <p className="text-muted" style={{ fontSize: '13px' }}>No past rounds yet in this event.</p>
  }

  return (
    <>
      {pastRounds.map(({ round: r, entry: e }) => {
        const badge = outcomeBadge(e)
        const winnerName = r.status === 'complete' ? winners.get(r.id) : null
        return (
          <a
            key={r.id}
            href={`/lms/${eventId}?round=${r.id}`}
            className="card-flat"
            style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '14px 16px', marginBottom: '8px', textDecoration: 'none', color: 'inherit'
            }}
          >
            <div>
              <div style={{ fontFamily: 'var(--ff-d)', fontSize: '16px', fontWeight: '700' }}>Round {r.round_number}</div>
              <div className="text-muted" style={{ fontSize: '12px' }}>
                R{r.pot_total} pot
                {r.status === 'complete' && winnerName && <> · Won by {winnerName}</>}
                {r.status === 'rolled_over' && <> · Rolled over, no survivor</>}
              </div>
            </div>
            <span className={badge.cls}>{badge.label}</span>
          </a>
        )
      })}
    </>
  )
}
